module.exports = "./img/c32d766d0bccc62888deb5fd7dfe8948.jpg";